export default typeof window !== 'undefined' && typeof document !== 'undefined';



// WEBPACK FOOTER //
// ../../src/utils/isBrowser.js